import { Component, OnInit } from '@angular/core';
import { GrievanceDashboardService } from '../grievance-dashboard.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  isCollapsed: boolean = false;
  activeView: any = '';
  savedView: any;
  roleDetails: any;

  showGrievanceuser1 = false;
  showGrievanceuser2 = false;
  showGrievanceAdmin = false;
  showGrievanceSuperAdmin = false;

  grievance1: any;
  grievance2: any;
  grievanceAdmin: any;
  grievancesuperadmin: any;

  constructor(private Service: GrievanceDashboardService, private router: Router, private spinner: NgxSpinnerService,) {

    // const storedView = localStorage.getItem('routeNames') || 'grievance';
    const storedView = localStorage.getItem('routeNames') || '';
    this.savedView = storedView;
    this.Service.setView(this.savedView);
    this.Service.view$.subscribe(view => {
      this.activeView = view;
    });

    this.Service.collapsed$.subscribe(data => {
      this.isCollapsed = data;
    });

  }

  ngOnInit(): void {
    this.rolemanagement();
  }

  // rolemanagement() {
  //   this.spinner.show();
  //   const payrollId = localStorage.getItem('userId')
  //   this.Service.getRolemanagement(payrollId).subscribe({
  //     next: (res: any) => {
  //       if (!res) {
  //         this.spinner.hide();
  //         return;
  //       }
  //       this.roleDetails = res;
  //       for (const group of this.roleDetails.userAppForms) {
  //         // Loop through each form in the group
  //         for (const form of group.appForms) {
  //           if (form.appFormName === "GRIEVANCE_LEVEL_1") {
  //             this.grievance1 = form.appFormLabel;
  //             this.showGrievanceuser1 = true;
  //           }
  //           else if (form.appFormName === 'GRIEVANCE_LEVEL_2') {
  //             this.grievance2 = form.appFormLabel;
  //             this.showGrievanceuser2 = false;
  //           }
  //           else if (form.appFormName === 'GRIEVANCE_ADMIN') {
  //             this.grievanceAdmin = form.appFormLabel;
  //             this.showGrievanceAdmin = false;
  //           }
  //           else if (form.appFormName === 'GRIEVANCE_SUPER_ADMIN') {
  //             this.grievancesuperadmin = form.appFormLabel;
  //             this.showGrievanceSuperAdmin = false;
  //           }
  //         }
  //       }
  //       this.spinner.hide();
  //     },
  //     error: (err: any) => {
  //       this.spinner.hide();
  //     }
  //   })
  // }

  rolemanagement() {
    localStorage.removeItem('routeNames');
    this.spinner.show();

    const payrollId = localStorage.getItem('userId');
    this.Service.getRolemanagement(payrollId).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }

        this.roleDetails = res;

        let hasAnyGrievanceAccess = false;

        for (const group of this.roleDetails.userAppForms) {
          for (const form of group.appForms) {
            switch (form.appFormName.trim()) {
              case 'GRIEVANCE_LEVEL_1':
                this.grievance1 = form.appFormLabel;
                this.showGrievanceuser1 = true;
                hasAnyGrievanceAccess = true;
                break;

              case 'GRIEVANCE_LEVEL_2':
                this.grievance2 = form.appFormLabel;
                this.showGrievanceuser2 = true;
                hasAnyGrievanceAccess = true;
                break;

              case 'GRIEVANCE_ADMIN':
                this.grievanceAdmin = form.appFormLabel;
                this.showGrievanceAdmin = true;
                hasAnyGrievanceAccess = true;
                break;

              case 'GRIEVANCE_SUPER_ADMIN':
                this.grievancesuperadmin = form.appFormLabel;
                this.showGrievanceSuperAdmin = true;
                hasAnyGrievanceAccess = true;
                break;
              default:
                console.warn('Unhandled form:', form.appFormName);
                break;
            }
          }
        }

        // Set localStorage based on grievance access
        const viewToSet = hasAnyGrievanceAccess ? 'grievance' : 'report';
        localStorage.setItem('routeNames', viewToSet);
        this.savedView = viewToSet;
        this.Service.setView(this.savedView);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    });
  }


  showtoGrievance() {
    this.Service.setView('grievance');
  }

  showtoReport() {
    this.Service.setView('report');
  }

  showtoGrievanceuser2() {
    this.Service.setView('grievanceuser2');
  }
  showtoAdmin() {
    this.Service.setView('grievanceAdmin');
  }

  showtoSuperAdmin() {
    this.Service.setView('grievanceSuperadmin');
  }


  refreshComponent() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/grievanceDashboard']);
    });
  }



  toggleCollapse() {
    this.Service.toggleCollapse();
    // const newWidth = this.isCollapsed ? '100%' : '92%';
    // this.Service.updateWidth(newWidth);
  }
}
